import styled from '@emotion/styled';
import { IconButton } from '@mui/material';

const PrimaryIconButton = styled(IconButton)(({ theme }) => ({
  color: theme.palette.text.primary,
}));

export default PrimaryIconButton;
